var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBordeBnkePicnic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#746d51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.478,9.478H12.386V7.892h1.092a.434.434,0,1,0,0-.867H10.426a.434.434,0,1,0,0,.867h1.092V9.478H8.394V5.744h2.145a.542.542,0,0,0,0-1.084H5.165a.542.542,0,0,0,0,1.084H7.31V9.478H4.073V7.892H5.165a.434.434,0,1,0,0-.867H2.113a.434.434,0,1,0,0,.867H3.2V9.478H2.17a.434.434,0,1,0,0,.867H13.478a.434.434,0,1,0,0-.867Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBordeBnkePicnic);
export default __webpack_public_path__ + "static/media/BORDE-BÆNKE-PICNIC.cd4dc583c9fd668e692d5fee5844985d.svg";
export { ForwardRef as ReactComponent };